import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/files/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/files/')({
  component: Page,
});
